<!--
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-08-02 10:16:52
 * @LastEditors: dudedu
 * @LastEditTime: 2022-10-28 16:43:58
-->
<template>
<div>
  introduction
</div>
</template>

<script>
export default {
  name: 'helpCenterIntroduction',
};
</script>

<style scoped>

</style>
